import styled, { css } from 'styled-components'

import {
  _S_Medium,
  _S_Normal,
  _XS_Bold,
  _XS_Medium,
  _XS_Normal,
  mainColors,
  semanticColors,
} from '@avantstay/backoffice-core'

export const Card = styled.section`
  border: 1px solid ${mainColors.neutralMedium};
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
`

export const SectionLabel = styled.h3`
  ${_XS_Bold};
  color: ${mainColors.neutralExtremelyDark};
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 0 0 8px;
`

export const FactRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 0;

  & + & {
    border-top: 1px solid ${mainColors.neutralMedium};
  }
`

export const FactLabel = styled.span`
  ${_S_Medium};
  color: ${mainColors.primaryMedium};
`

export const FactValue = styled.span`
  ${_S_Normal};
  color: ${mainColors.neutralExtremelyDark};
  text-align: right;
  min-width: 0;
  overflow-wrap: anywhere;
`

export const Prose = styled.p`
  ${_S_Normal};
  color: ${mainColors.primaryMedium};
  line-height: 1.55;
  margin: 0;
  overflow-wrap: anywhere;
`

export const EmptyState = styled.p`
  ${_S_Normal};
  color: ${mainColors.neutralExtremelyDark};
  margin: 24px 0;
  text-align: center;
`

const toneStyles = {
  good: css`
    color: ${semanticColors.successDark};
    background: ${semanticColors.successExtraLight};
  `,
  warn: css`
    color: ${semanticColors.warningExtraDark};
    background: ${semanticColors.warningExtraLight};
  `,
  bad: css`
    color: ${semanticColors.failureDark};
    background: ${semanticColors.failureExtraLight};
  `,
  neutral: css`
    color: ${mainColors.neutralExtremelyDark};
    background: ${mainColors.neutralLight};
  `,
}

export const Pill = styled.span<{ $tone?: keyof typeof toneStyles }>`
  ${_XS_Medium};
  border-radius: 4px;
  padding: 4px 8px;
  white-space: nowrap;
  flex: none;
  ${({ $tone }) => toneStyles[$tone ?? 'neutral']};
`

export const Note = styled.span`
  ${_XS_Normal};
  color: ${mainColors.neutralExtremelyDark};
  overflow-wrap: anywhere;
`

export type RoleTone = 'team' | 'vendor' | 'system'

const roleTones = {
  team: css`
    color: ${mainColors.primaryLight};
    background: ${mainColors.primaryExtraLight};
  `,
  vendor: css`
    color: ${semanticColors.warningExtraDark};
    background: ${semanticColors.warningExtraLight};
  `,
  system: css`
    color: ${mainColors.neutralExtremelyDark};
    background: ${mainColors.neutralLight};
  `,
}

export const RoleTag = styled.span<{ $tone: RoleTone }>`
  ${_XS_Bold};
  border-radius: 4px;
  padding: 0 4px;
  flex: none;
  ${({ $tone }) => roleTones[$tone]};
`

export const SystemLine = styled.div`
  ${_XS_Normal};
  color: ${mainColors.neutralExtremelyDark};
  text-align: center;
  margin: 12px 0;
  overflow-wrap: anywhere;
`

export const DayHeading = styled.h4`
  ${_XS_Medium};
  color: ${mainColors.neutralExtremelyDark};
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin: 24px 0 12px;
`
